import { useEffect } from 'react';
import { FileRejection } from 'react-dropzone';

export function useImagePaste(
  elementRef: React.RefObject<HTMLElement>,
  onDrop: (accepted: File[], rejected: FileRejection[]) => void,
  disabled?: boolean,
) {
  useEffect(() => {
    if (!elementRef.current || disabled) return;

    const handlePaste = (event: ClipboardEvent) => {
      const items = event.clipboardData?.items;
      if (!items) return;

      // Look for image items in clipboard
      const imageItem = Array.from(items).find(item => item.type.startsWith('image/'));

      if (imageItem) {
        event.preventDefault(); // Prevent default paste behavior

        const file = imageItem.getAsFile();
        if (file) {
          // Generate a filename with timestamp
          const extension = file.type.split('/')[1] || 'png';
          const filename = `pasted-image-${Date.now()}.${extension}`;

          // Create a new File object with the generated filename
          const renamedFile = new File([file], filename, { type: file.type });

          // Use the existing onDrop function to handle the file upload
          // Pass empty array for rejected files since we're handling images
          onDrop([renamedFile], []);
        }
      }
    };

    elementRef.current.addEventListener('paste', handlePaste);
    return () => elementRef.current?.removeEventListener('paste', handlePaste);
  }, [elementRef, onDrop, disabled]);
}
